const messages = {
  en: {
    importarListaPrecios: {
      menuTitle: "Import Price List",
      title: "Import Supplier Price List",
      step1: "Configuration",
      step2: "Column Mapping",
      step3: "Review & Apply",
      continuar: "Continue",
      back: "Back",
      saltar: "Skip",
      procesarArchivo: "Process File",
      // Step 2 - file
      selectFile: "Select file (CSV, XLSX, XLS)",
      clickColumnInstruction: 'Click the header of the column containing: "{field}"',
      columnAlreadyMapped: "This column is already assigned to another field",
      allFieldsMapped: "All fields mapped — ready to continue",
      // Fields SIMPLE
      fieldCodigoBarrasProveedor: "Supplier code",
      fieldNombre: "Product name",
      fieldPrecioCompra: "Purchase price",
      fieldDescuentoProveedor: "Supplier discount (%)",
      // Fields ESTRUCTURADO
      fieldMarca: "Brand",
      fieldModelo: "Model",
      fieldTamanio: "Size",
      fieldOtrasCaracteristicas: "Other characteristics",
      // Errors
      errorSeleccion: "Please select a file",
      errorArchivoInvalido: "Invalid file",
      errorFilasVacias: "No data rows found in the file",
      errorPrecioRequired: "Purchase price column must be mapped before continuing",
      errorIdentificadorRequired: "At least one identifier column (code or name) must be mapped",
      errorIdentificadorEstructurado: "At least one of Brand, Model, or Size must be mapped",
      errorProcesar: "Error processing file",
      // Wizard hints
      hintOptional: "(optional)",
      hintRequired: "(required)",
      mappedAs: "Mapped as: {field}",
      previewTitle: "File preview",
      totalRows: "{n} rows found in file",
    },
  },
  es: {
    importarListaPrecios: {
      menuTitle: "Importar lista de precios",
      title: "Importar lista de precios del proveedor",
      step1: "Configuración",
      step2: "Mapeo de columnas",
      step3: "Revisión y aplicación",
      continuar: "Continuar",
      back: "Atrás",
      saltar: "Saltar",
      procesarArchivo: "Procesar archivo",
      // Step 2 - file
      selectFile: "Seleccioná el archivo (CSV, XLSX, XLS)",
      clickColumnInstruction: 'Hacé click en el header de la columna que contiene: "{field}"',
      columnAlreadyMapped: "Esta columna ya está asignada a otro campo",
      allFieldsMapped: "Todos los campos mapeados — podés continuar",
      // Fields SIMPLE
      fieldCodigoBarrasProveedor: "Código del proveedor",
      fieldNombre: "Nombre del producto",
      fieldPrecioCompra: "Precio de compra",
      fieldDescuentoProveedor: "Descuento del proveedor (%)",
      // Fields ESTRUCTURADO
      fieldMarca: "Marca",
      fieldModelo: "Modelo",
      fieldTamanio: "Tamaño",
      fieldOtrasCaracteristicas: "Otras características",
      // Errors
      errorSeleccion: "Seleccioná un archivo",
      errorArchivoInvalido: "Archivo inválido",
      errorFilasVacias: "El archivo no contiene filas de datos",
      errorPrecioRequired: "Debés mapear la columna de Precio de compra antes de continuar",
      errorIdentificadorRequired: "Debés mapear al menos un identificador (código o nombre)",
      errorIdentificadorEstructurado: "Debés mapear al menos una de: Marca, Modelo o Tamaño",
      errorProcesar: "Error al procesar el archivo",
      // Wizard hints
      hintOptional: "(opcional)",
      hintRequired: "(requerido)",
      mappedAs: "Mapeado como: {field}",
      previewTitle: "Vista previa del archivo",
      totalRows: "{n} filas encontradas en el archivo",
    },
  },
  pt: {
    importarListaPrecios: {
      menuTitle: "Importar lista de preços",
      title: "Importar lista de preços do fornecedor",
      step1: "Configuração",
      step2: "Mapeamento de colunas",
      step3: "Revisão e aplicação",
      continuar: "Continuar",
      back: "Voltar",
      saltar: "Pular",
      procesarArchivo: "Processar arquivo",
      selectFile: "Selecione o arquivo (CSV, XLSX, XLS)",
      clickColumnInstruction: 'Clique no cabeçalho da coluna que contém: "{field}"',
      columnAlreadyMapped: "Esta coluna já está atribuída a outro campo",
      allFieldsMapped: "Todos os campos mapeados — pode continuar",
      fieldCodigoBarrasProveedor: "Código do fornecedor",
      fieldNombre: "Nome do produto",
      fieldPrecioCompra: "Preço de compra",
      fieldDescuentoProveedor: "Desconto do fornecedor (%)",
      fieldMarca: "Marca",
      fieldModelo: "Modelo",
      fieldTamanio: "Tamanho",
      fieldOtrasCaracteristicas: "Outras características",
      errorSeleccion: "Selecione um arquivo",
      errorArchivoInvalido: "Arquivo inválido",
      errorFilasVacias: "Nenhuma linha de dados encontrada",
      errorPrecioRequired: "Mapeie a coluna de Preço de compra antes de continuar",
      errorIdentificadorRequired: "Mapeie ao menos um identificador (código ou nome)",
      errorIdentificadorEstructurado: "Mapeie ao menos uma de: Marca, Modelo ou Tamanho",
      errorProcesar: "Erro ao processar o arquivo",
      hintOptional: "(opcional)",
      hintRequired: "(obrigatório)",
      mappedAs: "Mapeado como: {field}",
      previewTitle: "Pré-visualização do arquivo",
      totalRows: "{n} linhas encontradas no arquivo",
    },
  },
};

export default messages;
